import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import dayjs from 'dayjs';
import AbLinesTab from './AbLinesTab';
import AbMasterDataTab from './AbMasterDataTab';
import AbSyncsTab from './AbSyncsTab';
import AbTrialBalanceTab from './AbTrialBalanceTab';

const EMPTY_FILTER = {
  period: null,
  account: '',
  partner: '',
  orderNo: '',
  text: '',
};

/**
 * What arrived from AB Soft, before any report is made of it: deliveries,
 * journal lines, the trial balance they add up to, and the registers.
 * Read-only.
 *
 * @param {Object} props - Component props
 * @param {string} props.companyId - Company
 * @returns {JSX.Element} The panel
 */
export default function AbDataPanel({ companyId }) {
  const { t } = useTranslation('clientReports');
  const [tab, setTab] = useState('trialBalance');
  const [linesFilter, setLinesFilter] = useState(EMPTY_FILTER);
  const [year, setYear] = useState(dayjs().subtract(1, 'month').year());

  const openLines = ({ account, period }) => {
    setLinesFilter({ ...EMPTY_FILTER, account, period });
    if (period) setYear(period.year());
    setTab('lines');
  };

  return (
    <Tabs
      size="small"
      activeKey={tab}
      onChange={setTab}
      items={[
        {
          key: 'trialBalance',
          label: t('ab.tabTrialBalance'),
          children: (
            <AbTrialBalanceTab companyId={companyId} onOpenLines={openLines} />
          ),
        },
        {
          key: 'lines',
          label: t('ab.tabLines'),
          children: (
            <AbLinesTab
              companyId={companyId}
              year={year}
              filter={linesFilter}
              onFilterChange={setLinesFilter}
            />
          ),
        },
        {
          key: 'syncs',
          label: t('ab.tabSyncs'),
          children: <AbSyncsTab companyId={companyId} />,
        },
        {
          key: 'master',
          label: t('ab.tabMaster'),
          children: <AbMasterDataTab companyId={companyId} />,
        },
      ]}
    />
  );
}
